// День или месяц сводки (`YYYY-MM-DD`, по UTC) → полночь этого дня по местному времени:
// так `Intl` покажет тот же день и месяц в любом часовом поясе.
export const localDate = (day: string): Date =>
  new Date(Number(day.slice(0, 4)), Number(day.slice(5, 7)) - 1, Number(day.slice(8, 10)));
